import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { kebabCase } from 'lodash';
import { mergeDeepLeft } from 'ramda';
import Select from '../../../common/controls/select';
import OptionNestedPickerModal from './optionNestedPickerModal';
import { removeFromTree, identifiersFromTree, titleForIdentifier } from './optionNestedPickerHelpers';
import { applyNullRemove, removeNulls } from '../../../../utils/contentTools';
import { leafPedigreesString } from '../../../../../behaviors/src/lib/common';
class OptionNestedPicker extends Component {
  constructor(props) {
    super(props);
    this.modalOpen = this.onModalChange.bind(this, true);
    this.modalClose = this.onModalChange.bind(this, false);
    this.onSelectChange = this.onSelectChange.bind(this);
    this.onNestedPickerChange = this.onNestedPickerChange.bind(this);
    this.state = {
      isOpen: false
    };
  }
  onModalChange(isOpen) {
    this.setState({
      isOpen
    });
  }
  onSelectChange(newValues) {
    const _this$props = this.props,
      value = _this$props.value,
      onChange = _this$props.onChange,
      path = _this$props.path;
    if (newValues.length === 0) {
      return onChange({
        path,
        value: null
      });
    }
    const currentIdentifiers = identifiersFromTree(value);
    const removedIdentifier = currentIdentifiers.find(currentIdentifier => !newValues.some(item => item.identifier === currentIdentifier));
    const updatedTree = removeFromTree(value, removedIdentifier);
    const d = JSON.parse(JSON.stringify(updatedTree));
    const displayValue = leafPedigreesString(removeNulls(d));
    return onChange({
      path,
      value: updatedTree,
      displayValue
    });
  }
  onNestedPickerChange(_ref) {
    let tree = _ref.value,
      _ref$changeModifiers = _ref.changeModifiers,
      changeModifiers = _ref$changeModifiers === void 0 ? {} : _ref$changeModifiers;
    const _this$props2 = this.props,
      onChange = _this$props2.onChange,
      path = _this$props2.path,
      value = _this$props2.value,
      allowsMultipleSelection = _this$props2.allowsMultipleSelection;
    let saveTree = tree;
    if (saveTree === null) {
      return onChange({
        path,
        value: null,
        changeModifiers
      });
    }
    if (allowsMultipleSelection) {
      saveTree = mergeDeepLeft(saveTree, value);
    }
    saveTree = applyNullRemove(saveTree);
    const d = JSON.parse(JSON.stringify(saveTree));
    const displayValue = leafPedigreesString(removeNulls(d));
    return onChange({
      path,
      value: saveTree,
      displayValue,
      changeModifiers
    });
  }
  render() {
    const _this$props3 = this.props,
      value = _this$props3.value,
      placeholder = _this$props3.placeholder,
      enabled = _this$props3.enabled,
      allowsMultipleSelection = _this$props3.allowsMultipleSelection,
      className = _this$props3.className,
      formatLabel = _this$props3.label,
      allowsOther = _this$props3.allowsOther,
      allowsParentSelection = _this$props3.allowsParentSelection,
      options = _this$props3.options;
    const isOpen = this.state.isOpen;
    const identifiers = identifiersFromTree(value);
    const values = identifiers.map(identifier => {
      const label = titleForIdentifier(value, identifier);
      return {
        label,
        identifier,
        value: identifier,
        clearableValue: true,
        className: "t-onp-opt-".concat(kebabCase(label))
      };
    });
    let contentValue = values;
    if (contentValue.length === 0) {
      contentValue = '';
    }
    let selectValue;
    if (!allowsMultipleSelection && contentValue) {
      selectValue = values[0];
    } else if (contentValue) {
      selectValue = contentValue.map(val => val.value);
    } else {
      selectValue = '';
    }
    return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Select, {
      backspaceRemoves: false,
      onChange: this.onSelectChange,
      onOpen: this.modalOpen,
      options: values,
      labelKey: "label",
      valueKey: "value",
      id: "select",
      className: "t-onp ".concat(className),
      multi: true,
      placeholder: placeholder,
      disabled: !enabled,
      values: selectValue,
      verticalPadding: false
    }), /*#__PURE__*/React.createElement(OptionNestedPickerModal, {
      allowsMultipleSelection: allowsMultipleSelection,
      allowsOther: allowsOther,
      allowsParentSelection: allowsParentSelection,
      className: className,
      closeModal: this.modalClose,
      isOpen: isOpen,
      label: formatLabel,
      onChange: this.onNestedPickerChange,
      options: options,
      value: value
    }));
  }
}
OptionNestedPicker.propTypes = {
  allowsMultipleSelection: PropTypes.bool,
  allowsOther: PropTypes.bool,
  allowsParentSelection: PropTypes.bool,
  className: PropTypes.string,
  enabled: PropTypes.bool,
  label: PropTypes.string,
  path: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  options: PropTypes.arrayOf(PropTypes.shape({})),
  placeholder: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.shape({}), PropTypes.string])
};
OptionNestedPicker.defaultProps = {
  allowsMultipleSelection: false,
  allowsOther: false,
  allowsParentSelection: true,
  className: '',
  enabled: true,
  label: '',
  options: [],
  placeholder: 'Select...',
  value: {}
};
export default OptionNestedPicker;